<template lang="pug">
  .card#meet
</template>

<script>
import { mapGetters } from 'vuex';
import Jitsi from '../../helpers/jitsi';

export default {
  name: 'Rooms',
  data() {
    return {
      teamId: null,
      profile: this.initProfile(),
      jitsi: null,
      meeting() {
        return this.$route.params;
      },
    };
  },
  computed: {
    title() {
      // Instead of %20 for space we use +
      const title = this.$route.params.title.replaceAll('+', ' ');
      return decodeURIComponent(title);
    },
    ...mapGetters('users', ['me']),
  },
  watch: {
    created() {
      console.log(this.getMe());
    },
    me(val) {
      console.log(val);
      this.init();
    },
  },
  mounted() {
    this.initialiseJitsi();
    this.init();
  },
  methods: {
    init() {
      if (this.me) {
        console.log(this.me);
        const { userRecord } = this.me;
        if (userRecord) {
          this.profile.firstName = userRecord.firstName;
          this.profile.lastName = userRecord.lastName;
          this.profile.email = userRecord.email;
          this.initialiseJitsi();
          this.jitsi.setDisplayName(`${this.profile.firstName} ${this.profile.lastName}`);
        }
      }
    },
    initialiseJitsi() {
      if (!this.jitsi) {
        this.jitsi = new Jitsi(this.meeting(), this.user);
        this.jitsi.initJitsi();
        this.jitsi.setAvatar();
        this.jitsi.setTitle(this.title);
        window.addEventListener('message', (e) => {
          if (e.data === 'endCall') {
            this.$router.push('/meetings');
          }
        });
      }
    },
    initProfile() {
      console.log('....init profile ....');
      return {
        firstName: '',
        lastName: '',
        imageUrl: '',
        email: '',
      };
    },
  },
};
</script>
